import React, { useState } from "react";
import Chatroom from "../components/ui/Chatroom";
import InvestDashboard from "../components/ui/InvestDashboard";
import VIP from "../components/ui/VIP";

function Invest() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Dashboard",
      content: <InvestDashboard />,
    },
    {
      title: "Chatroom",
      content: <Chatroom />,
    },
    {
      title: "VIP",
      content: <VIP />,
    },
  ];

  return (
    <div className="page_overflow">
      <section className="repair_credit">
        <div className="container">
          <div className="section_title mb-2">
            <h2>Invest</h2>
          </div>
          <div className="tabs-container mt-2">
            {/* Render tab titles */}
            <div className="tabs">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`tab ${activeTab === index ? "active" : ""}`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>

            {/* Render active tab content */}
            <div className="tab-content">{tabs[activeTab].content}</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Invest;
